<script>
import Row from "./show/row";
import Loader from "../widgets/loader";

export default {
  name: "ModelShow",
  components: {
    Loader
  },
  props: {
    sectionTitle: { type: String, default: undefined },
    cardTitle: { type: String, default: undefined },
    loading: { type: Boolean, default: false },
    resourceRoute: String,
    modelVariable: String,
    modelKey: { type: String, default: "id" },
    columns: {
      type: Object,
      default() {
        return {
          [this.modelVariable || "model"]: [
            {
              key: "key",
              label: this.$t("models.key"),
              component: Row
            }
          ]
        };
      }
    },
    cardAttrs: {
      type: Object,
      default() {
        return { title: null, subTitle: null };
      }
    },
    denyBack: { type: Boolean, default: false },
    denyEdit: { type: Boolean, default: false },
    denyDelete: { type: Boolean, default: false },
    denyFooter: { type: Boolean, default: false },
    printable: { type: Boolean, default: false },
    busy: { type: Boolean, default: false },
    modelMapped: {
      type: Array,
      default() {
        return [];
      }
    },
    tableProps: {
      type: Object,
      default() {
        return {};
      }
    },
    value: {
      type: Object,
      default() {
        return {};
      }
    },
    tableHeight: { type: Number, default: 530 }
  },
  methods: {
    handleBack(event) {
      this.$emit("back-click", event);
    },
    handleEdit(event) {
      this.$emit("edit-click", event);
    },
    handleDelete(event) {
      this.$emit("delete-click", event);
    },
    handlePrint(event) {
      this.$emit("print-click", event);
    }
  }
};
</script>

<template>
  <div>
    <h4 class="mb-2 font-size-14" v-if="sectionTitle">{{ sectionTitle }}</h4>
    <b-card v-bind="cardAttrs" :title="undefined" :sub-title="undefined">
      <b-card-title title-tag="div" class="clearfix" v-if="cardTitle">
        <slot name="card-header" v-bind="{ cardAttrs, cardTitle, resourceRoute }">
          <b-card-title>{{
            cardAttrs.title || `${$t("Detail")} ${cardTitle || lodash.startCase($t(resourceRoute + ".singular"))}`
          }}</b-card-title>
          <b-card-sub-title v-if="cardAttrs.subTitle">{{ cardAttrs.subTitle }}</b-card-sub-title>
        </slot>
      </b-card-title>
      <slot>
        <div>
          <slot name="content">
            <b-table
              ref="table"
              :busy="busy"
              @update:busy="$emit('update:busy', $event)"
              :items="modelMapped"
              :fields="columns[modelVariable]"
              show-empty
              :responsive="true"
              thead-class="d-none"
              borderless
              v-bind="tableProps"
              table-class="table-model"
            >
              <template #cell()="data">
                <template v-if="data.field.component">
                  <component
                    :is="data.field.component"
                    v-bind="{ item: data.item }"
                    v-on="data.field['componentListeners'] || {}"
                  ></component>
                </template>
                <template v-else>{{ data.value }}</template>
              </template>
              <template #empty="scope">
                <Loader :loading="loading" no-axios>
                  <div :style="{ maxHeight: `${tableHeight}px` }">
                    <p class="my-5">{{ lodash.upperFirst($t("no_data")) }}</p>
                  </div>
                </Loader>
              </template>
              <template #emptyfiltered="scope">
                <Loader :loading="loading" no-axios>
                  <div :style="{ maxHeight: `${tableHeight}px` }">
                    <p class="my-5">{{ lodash.upperFirst($t("search_not_found")) }}</p>
                  </div>
                </Loader>
              </template>
            </b-table>
          </slot>
        </div>
      </slot>
      <slot name="card-footer">
        <div class="h-100 d-flex justify-content-end align-items-end p-2" v-if="!denyFooter">
          <div>
            <div class="row d-print-none px-2">
              <div class="col-12 d-flex flex-row-reverse justify-content-start flex-wrap">
                <b-button
                  v-if="printable"
                  @click="handlePrint"
                  class="btn btn-success waves-effect waves-light me-1 ms-2"
                  ><i class="fa fa-print"></i>Print
                </b-button>
                <b-button
                  class="ms-2"
                  v-if="!denyEdit && !value['_denyEdit']"
                  native-type="submit"
                  variant="primary"
                  @click="handleEdit"
                >
                  {{ $t("Edit") }}
                </b-button>
                <b-button
                  class="ms-2"
                  v-if="!loading && !denyDelete && !value['_denyDelete']"
                  native-type="submit"
                  variant="outline-danger"
                  @click="handleDelete"
                >
                  {{ $t("Delete") }}
                </b-button>
                <b-button class="ms-2" v-if="!denyBack && !value['_denyBack']" variant="link" @click="handleBack">
                  {{ $t("Back") }}
                </b-button>
              </div>
            </div>
          </div>
        </div>
      </slot>
    </b-card>
  </div>
</template>
